import { HexButtonClass } from "@/common/buttons";
import { HexagonButtonProps } from "@/types/components";

const HexagonButton: React.FC<HexagonButtonProps> = ({
  children,
  width,
  backgroundColor,
  onClick,
  marginX,
  marginY,
}) => {
  return (
    <>
      <HexButtonClass
        data-testid="HexagonButton"
        width={width}
        backgroundColor={backgroundColor}
        marginX={marginX}
        marginY={marginY}
        height="auto"
        onClick={(e) => {
          e.stopPropagation();
          onClick();
        }}
      >
        {children}
      </HexButtonClass>
      <svg
        style={{ visibility: "hidden", position: "absolute" }}
        width="0"
        height="0"
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
      >
        <defs>
          <filter id="round">
            <feGaussianBlur in="SourceGraphic" stdDeviation="3" result="blur" />
            <feColorMatrix
              in="blur"
              mode="matrix"
              values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 19 -9"
              result="goo"
            />
            <feComposite in="SourceGraphic" in2="goo" operator="atop" />
          </filter>
        </defs>
      </svg>
    </>
  );
};

export default HexagonButton;
